import React from 'react';
import DemoStage from '../DemoStage.jsx';

/**
 * Animated All Cases overview: quick filters along the top act as status
 * shortcuts — click Open and the mini table narrows to matching rows.
 * Distinct from SearchFilterDemo (search box typing).
 */

const ROWS = [
  { ref: 'AE-042', clinic: 'Clinic_A', cls: 'status-open', status: 'Open' },
  { ref: 'AE-017', clinic: 'Clinic_B', cls: 'status-new',  status: 'New' },
  { ref: 'AE-123', clinic: 'Clinic_C', cls: 'status-inv',  status: 'Pending' },
  { ref: 'AE-390', clinic: 'Clinic_A', cls: 'status-wait', status: 'Waiting on Client' },
];

const CARDS = [
  { key: 'new',      label: 'New',                 value: 1, filter: 'New' },
  { key: 'open',     label: 'Open',                value: 1, filter: 'Open' },
  { key: 'pending',   label: 'Pending',              value: 1, filter: 'Pending' },
  { key: 'waiting',  label: 'Waiting on Client',   value: 1, filter: 'Waiting on Client' },
  { key: 'closed',   label: 'Closed',              value: 0, filter: 'Closed' },
];

const STEPS = [
  {
    caption: 'All Cases is already scoped to your role — quick filters summarise what you can see.',
    scene: 'all', ms: 2600,
  },
  {
    caption: 'Click a filter to focus the list — Open, Pending, New and the rest work the same way.',
    scene: 'open-card', ms: 2200,
    cursor: 'stat-open', click: true,
  },
  {
    caption: 'The table narrows straight away to cases in that status.',
    scene: 'open-filtered', ms: 2600,
    cursor: 'row-AE-042',
  },
  {
    caption: 'Open a case from the row — Previous and Next walk the same filtered list.',
    scene: 'open-filtered', ms: 2800,
    cursor: 'row-AE-042', click: true,
  },
];

export default function CaseListOverviewDemo() {
  return (
    <DemoStage steps={STEPS} label="The All Cases list and quick filters" height={280}>
      {(step) => {
        const scene = step?.scene ?? 'all';
        const activeCard = scene === 'open-card' || scene === 'open-filtered' ? 'open' : null;
        const rows = scene === 'open-filtered'
          ? ROWS.filter(r => r.status === 'Open')
          : ROWS;
        return (
          <div className="kb-mock">
            <div
              className="kpi-grid"
              style={{ gridTemplateColumns: 'repeat(5, minmax(0, 1fr))', marginBottom: 14, gap: 10 }}
            >
              {CARDS.map(c => (
                <div
                  key={c.key}
                  data-kb-target={`stat-${c.key}`}
                  className={`kpi clickable brand${activeCard === c.key ? ' kb-pop' : ''}`}
                  style={{
                    padding: '10px 12px',
                    opacity: activeCard && activeCard !== c.key ? 0.55 : 1,
                    outline: activeCard === c.key ? '2px solid var(--brand)' : undefined,
                    outlineOffset: activeCard === c.key ? 2 : undefined,
                    transition: 'opacity 300ms var(--ease), outline 300ms var(--ease)',
                  }}
                >
                  <div className="kpi-label" style={{ fontSize: 11 }}>{c.label}</div>
                  <div className="kpi-value" style={{ fontSize: 22, margin: '4px 0 0' }}>{c.value}</div>
                </div>
              ))}
            </div>
            <div className="table-scroll">
              <table aria-hidden="true">
                <thead>
                  <tr>
                    <th>Case ID</th>
                    <th>Clinic</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map(r => (
                    <tr key={r.ref} data-kb-target={`row-${r.ref}`}>
                      <td className="case-id">{r.ref}</td>
                      <td>{r.clinic}</td>
                      <td>
                        <span className={`badge ${r.cls}`}><span className="dot" />{r.status}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );
      }}
    </DemoStage>
  );
}
